export default {prompt:"Where is the text in relation to the picture?",
field:"stack",
type:"class",
default:"overlay",
options:[
    {value:"block",text:"Above"},
    {value:"overlay",text:"Within"}
]
}